export default function (state = 0, action) {
  switch (action.type) {
    case "COUNT_EXPERTS":
      return action.payload;
      break;
    default:
      return state;
  }
}
